/**
 * Feature-specific query keys for merchants
 * Co-located with the merchant feature for better organization
 */

export const merchantQueryKeys = {
  all: ["merchants"] as const,
  list: (params: {
    page?: number;
    size?: number;
    term?: string;
    sort?: string[];
    networkId?: string;
    regions?: string[];
    merchantStatuses?: string[];
    contractStatuses?: string[];
    hasShop?: boolean;
  }) => ["merchants", "list", params] as const,
  detail: (id: string) => ["merchants", "detail", id] as const,
} as const;